import { BinaryWriter } from "../binary.js";
import { ClientOp } from "../opcodes.js";
export function encodeAuth(packet, writer = new BinaryWriter(64)) {
    writer.u8(ClientOp.Auth).str8(packet.token);
    return writer;
}
export function decodeAuth(reader) {
    return { token: reader.str8() };
}
//# sourceMappingURL=auth.js.map